import { render, staticRenderFns } from "./CommonDetail.vue?vue&type=template&id=84cfa36c&scoped=true"
import script from "./CommonDetail.vue?vue&type=script&lang=js"
export * from "./CommonDetail.vue?vue&type=script&lang=js"
import style0 from "./CommonDetail.vue?vue&type=style&index=0&id=84cfa36c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cfa36c",
  null
  
)

export default component.exports